<template>
    <div>
       <slot name="title" v-bind="{ toggleIsActive, isActive }"></slot>
        <div v-show="isActive">
            <slot v-bind="{ toggleIsActive, isActive }"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isActive: this.isOpen
        };
    },
    methods: {
        toggleIsActive() {
            this.isActive = !this.isActive;
        }
    },
};
</script>
